import { render, staticRenderFns } from "./SemtelForm.vue?vue&type=template&id=51ea2b8a&scoped=true&"
import script from "./SemtelForm.vue?vue&type=script&lang=js&"
export * from "./SemtelForm.vue?vue&type=script&lang=js&"
import style0 from "./SemtelForm.vue?vue&type=style&index=0&id=51ea2b8a&lang=less&scoped=true&"
import style1 from "./SemtelForm.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ea2b8a",
  null
  
)

export default component.exports